import PropTypes from 'prop-types';
import React from 'react';
import { CheckCircleFill, Info, X } from 'react-bootstrap-icons';

import useTranslation from '../../hooks/use_translation';
import BtnIcon from '../framework/buttons/btn_icon';

const ItemButton = ({ handleAction, inCart }) => {
	const { t } = useTranslation('component_item_button');

	const statuses = {
		no: {
			className: 'btn-dark text-white',
			title: t('t1'),
		},
		other: {
			className: 'bg-primary-light btn-light text-dark',
			extra: {
				icon: <Info className="small" />,
			},
			icon: <CheckCircleFill className="small ms-1" />,
			title: t('t2'),
		},
		replaced: {
			className: 'btn-primary-light border-0 text-white',
			extra: {
				icon: <Info className="small" />,
			},
			title: t('t3'),
		},
		yes: {
			className: 'bg-primary-light border-0 text-dark',
			extra: {
				icon: <X className="small" />,
			},
			icon: <CheckCircleFill className="small ms-1" />,
			title: t('t4'),
		},
	};

	return (
		<>
			<button
				className={`btn btn-shop rounded-pill px-1 w-100 ${
					statuses[inCart.status]?.className
				}`}
				onClick={handleAction}
			>
				{statuses[inCart.status]?.title && (
					<span>{statuses[inCart.status]?.title}</span>
				)}

				{statuses[inCart.status]?.icon && <>{statuses[inCart.status]?.icon}</>}
			</button>

			{statuses[inCart.status]?.extra && (
				<BtnIcon
					className={`ms-1 ${statuses[inCart.status]?.extra?.className}`}
					onClick={handleAction}
				>
					{statuses[inCart.status]?.extra?.icon}
				</BtnIcon>
			)}
		</>
	);
};

ItemButton.propTypes = {
	handleAction: PropTypes.func,
	inCart: PropTypes.object,
};

export default ItemButton;
